export default __webpack_public_path__ + "static/media/make-it-beautiful.bd829ff6.webp";